"use strict";
/**
 * This code was GENERATED using the solita package.
 * Please DO NOT EDIT THIS FILE, instead rerun solita to update it or write a wrapper to add functionality.
 *
 * See: https://github.com/metaplex-foundation/solita
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.settleFundsInstructionDiscriminator = exports.SettleFundsStruct = void 0;
exports.createSettleFundsInstruction = createSettleFundsInstruction;
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const WrapperSettleFundsParams_1 = require("../types/WrapperSettleFundsParams");
/**
 * @category Instructions
 * @category SettleFunds
 * @category generated
 */
exports.SettleFundsStruct = new beet.BeetArgsStruct([
    ['instructionDiscriminator', beet.u8],
    ['params', WrapperSettleFundsParams_1.wrapperSettleFundsParamsBeet],
], 'SettleFundsInstructionArgs');
exports.settleFundsInstructionDiscriminator = 5;
/**
 * Creates a _SettleFunds_ instruction.
 *
 * Optional accounts that are not provided will be omitted from the accounts
 * array passed with the instruction.
 * An optional account that is set cannot follow an optional account that is unset.
 * Otherwise an Error is raised.
 *
 * @param accounts that will be accessed while the instruction is processed
 * @param args to provide as instruction data to the program
 *
 * @category Instructions
 * @category SettleFunds
 * @category generated
 */
function createSettleFundsInstruction(accounts, args, programId = new web3.PublicKey('UMnFStVeG1ecZFc2gc5K3vFy3sMpotq8C91mXBQDGwh')) {
    const [data] = exports.SettleFundsStruct.serialize({
        instructionDiscriminator: exports.settleFundsInstructionDiscriminator,
        ...args,
    });
    const keys = [
        {
            pubkey: accounts.wrapperState,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.owner,
            isWritable: false,
            isSigner: true,
        },
        {
            pubkey: accounts.traderTokenAccountBase,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.traderTokenAccountQuote,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.market,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.vaultBase,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.vaultQuote,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.mintBase,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.mintQuote,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.tokenProgramBase,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.tokenProgramQuote,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.manifestProgram,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.platformTokenAccount,
            isWritable: true,
            isSigner: false,
        },
    ];
    if (accounts.referrerTokenAccount != null) {
        keys.push({
            pubkey: accounts.referrerTokenAccount,
            isWritable: true,
            isSigner: false,
        });
    }
    const ix = new web3.TransactionInstruction({
        programId,
        keys,
        data,
    });
    return ix;
}
